<template>
  <header :class="[baseClass, variantClass].join(' ')">
    <v-container class="hvh-content-header__container">
      <div class="hvh-content-header__heading hvh-relative">
        <slot name="heading" />
      </div>
      <div class="hvh-content-header__actions" v-if="hasActionsSlot">
        <slot name="actions" />
      </div>
      <div class="hvh-content-header__content" v-if="hasContentSlot">
        <slot name="content" />
      </div>
      <div class="hvh-content-header__footer" v-if="hasFooterSlot">
        <slot name="footer" />
      </div>
    </v-container>
  </header>
</template>

<script>
export default {
  props: ['variant'],
  data() {
    return {
      baseClass: 'hvh-content-header',
    };
  },
  computed: {
    variantClass() {
      return `${this.baseClass}--${this.variant}`;
    },
    hasActionsSlot() {
      return !!this.$slots.actions;
    },
    hasContentSlot() {
      return !!this.$slots.content;
    },
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
  },
};
</script>

<style lang="scss">
.hvh-content-header {
  padding: rem(30px) 0 0;
  position: relative;
  z-index: 1;

  &.hvh-content-header--analysis {
    background: $color-white;
    box-shadow: 0 5px 10px 0 $color-shadow-default;
  }

  &.hvh-content-header--flow {
    font-size: rem(18px);
    line-height: 1.55;

    .hvh-content-header__container {
      padding-bottom: 0;
    }

    .hvh-cohort-step {
      font-size: rem(18px);
      font-weight: 600;
      color: $color-gray-3;
    }

    .hvh-cohort-title {
      font-size: rem(28px);
      color: $color-dark-blue;
    }

    .hvh-cohort-subtitle {
      font-size: rem(22px);
      color: $color-dark-blue;
    }

    .hvh-cohort-subheader {
      font-size: rem(16px);
      line-height: 1.5;
    }
  }

  .hvh-h1 {
    line-height: 1.15;
  }

  .hvh-h1__sub {
    display: block;
    font-size: rem(20px);
    font-weight: 600;
    letter-spacing: 0.25px;
  }
}

.hvh-content-header__container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.hvh-content-header__heading {
  flex: 1 1 auto;
  margin-bottom: rem(36px);
  max-width: rem(500px);

  .hvh-content-header--analysis &,
  .hvh-content-header--cohort & {
    display: flex;
  }

  p {
    margin-bottom: 0;

    .hvh-content-header--cohort-list & {
      font-size: rem(18px);
    }
  }

  .hvh-icon {
    flex: 0 0 auto;
    margin-top: rem(10px);
    margin-right: rem(20px);
  }
}

.hvh-content-header__actions {
  flex: 0 0 auto;

  .hvh-callout {
    margin: rem(8px);
  }
}

.hvh-content-header__content {
  width: 100%;
  margin-bottom: rem(30px);
}

.hvh-content-header__footer {
  border-top: 1px solid $color-gray-1;
  padding: rem(20px) 0 0;
  width: 100%;

  .v-btn {
    font-size: rem(15px);
    margin: 0;
  }
}
</style>
